<template>
  <div class="cd_copyright">
    &copy; {{year}} Friends of Deckers Creek
  </div>
</template>

<script>
export default {
  name: 'FooterCopyright',
  data () {
    return {
      year: (new Date).getFullYear()
    }
  }
}
</script>
